module.exports = __webpack_public_path__ + "97a4a44b2336e946fa642712e73e5d1b.pdf";